import { isUndefinedOrNull } from '../../../TypeHelpers';
export default function lastOrDefault(enumerable, predicate) {
    let array = enumerable.toArray().reverse();
    if (array.length == 0) {
        return null;
    }
    if (!isUndefinedOrNull(predicate)) {
        array = array.filter(predicate);
    }
    if (array.length > 0) {
        return array[0];
    }
    else {
        return null;
    }
}
